<template>
  <div
    class="dui-upload-trigger"
    @click="clickHandler()"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    targetInput: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    targetInputEl: null,
  }),
  mounted() {
    this.setupTarget();
  },
  methods: {
    clickHandler() {
      if (!this.targetInputEl) {
        return;
      }

      this.targetInputEl.click();
    },

    setupTarget() {
      this.targetInputEl = document.querySelector(this.targetInput);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-upload-trigger {
  cursor: pointer;

  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }
}
</style>
